export default __webpack_public_path__ + "locales/el-GR/WebPlugins.json?hash=72de9ec249a2c06de284879fbca4e16a";